//funzione per creare la struttura della toc( richiamando il componente checkbox e la struttura ad albero per i vari layer)
import React from 'react';
import "leaflet.locatecontrol";
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import TreeItem from '@material-ui/lab/TreeItem';
import CheckBox from './ActionLayer/CheckBoxLayer'
import MoreButton from './MoreButton'
import ImageLayer from './ImageLayer'

const useStyles = makeStyles({
  root: {
    height: 110,
    flexGrow: 1,
    maxWidth: 400,
    zIndex: 1,
  },
});

const TocList = (props) => {
  
  const classes = useStyles();
  const check = (nodes) =>{
    
    return(<CheckBox nodes={nodes} ></CheckBox> )
  }

  const renderLabel = nodes => (
    
    <span
      onClick={event => {
        // Blocco apertura collapse al click di more
        event.stopPropagation();
        // event.preventDefault();
      }}
    >
      
      
        <div className={"treeItem"}>{( nodes.id === 'root' ||  nodes.name === "") ?  null : check(nodes)}<div className={"textItem"}>{nodes.name}</div> {nodes.id === 'root' ? null : nodes.name === "" ? <ImageLayer nodes={nodes}/> : <MoreButton nodes={nodes} idNodes={nodes.id}/>}</div>
    </span>
  );



  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={(nodes.id).toString()} label={ renderLabel(nodes) }>
      
      {Array.isArray(nodes.children) ? nodes.children.map((node) => renderTree(node)) : null}
    </TreeItem>
  );

    return (
      
      <TreeView
      className={classes.root}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpanded={['root']}
     
      defaultExpandIcon={<ArrowRightIcon />}
    >
       
      {renderTree(props.data)}
    </TreeView>)
};


export default  TocList;